import { combineReducers } from 'redux';

// Front
import LayoutReducer from './layouts/reducer';

// Authentication
import AuthReducer from './auth/reducer';
import PromotionReducer from './promotions/reducer';
import DashboardReducer from './dashboard/reducer';
import OrganizationReducer from './organization/reducer';
import AnalyticsReducer from './analytics/reducer';

const rootReducer = combineReducers({
  layout: LayoutReducer,
  user: AuthReducer,
  dashboard: DashboardReducer,
  promotions: PromotionReducer,
  organization: OrganizationReducer,
  analytics: AnalyticsReducer,
});

export default rootReducer;
